"use client";
import usePermission from "@/hooks/usePermission";

/**
 * Gate children behind one or more permissions.
 *
 * `required` may be a single permission or an array (any-of), so a page can be
 * reachable either via a specific permission ("AddProducts") or a broader one
 * ("Products"). Resolution is delegated to usePermission so permission logic
 * (parsing, admin bypass) lives in exactly one place.
 */
export default function PermissionGuard({ required, children, fallback = null, requireAll = false }) {
    const allowed = usePermission(required, requireAll);
    return allowed ? <>{children}</> : fallback;
}
